import { createReducer, on } from '@ngrx/store';
import {
  currentDeleteScreen,
  deleteScreens,
  generatePages,
  getAppNavigation,
  getChildrenForElement,
  getChildTables,
  getFieldsInfoForTable,
  getIdMapping,
  getScreens,
  getScreenStructure,
  saveScreens,
  setAppNavigation,
  setChildrenForElement,
  setChildTables,
  setErrorMessage,
  setFieldsInfoForTable,
  setIdMapping,
  setNewlyAddedScreen,
  updateLandScr,
  setScreenStructure,
  setSelectedScreens,
  updateCurrentScreen,
  updateFieldsInfoForTable,
  updateScreens,
  updateScreenStructure,
  setLandngScreen,
  saveconfAndFileCntSuccess,
  saveconfAndFileCntFailure,
  updateScnAndDMCOnfig,
  getTableOrder,
  setTableOrder,
  getPagesForQuery,
  getTablesForQuery,
  setPagesForQuery,
  setTablesForQuery,
  getQueryTableData,
  setQueryTableData,
  getStandardListPages,
  setStandardListPages,
  getTableData,
  setTableData,
  setMsScreenData,
  deletePageVariable,
  savePageVariable,
  getPageVariables,
  setPageVariables,
  deletePageVariableSuccess,
  savePageVariableSuccess,
  setQueryMapData
} from '../actions/screens.actions';

export interface ScreensState {
  data: any;
  appNavStructure: any;
  selectedScreens: any;
}

export const initialState: ScreensState = {
  data: {},
  appNavStructure: {},
  selectedScreens: null
};

export const screensReducer = createReducer(
  initialState,
  on(getAppNavigation, (state, { appNavApiConstants }) => ({
    ...state,
    ...appNavApiConstants
  })),
  on(setAppNavigation, (state, { appNavStructure }) => ({
    ...state,
    ...{ appNavStructure }
  })),
  on(getScreens, (state, { getScreensApiConstants }) => ({
    ...state,
    ...{ getScreensApiConstants }
  })),
  on(getIdMapping, (state, { getIdMappingApiConstants }) => ({
    ...state,
    ...{ getIdMappingApiConstants }
  })),
  on(setIdMapping, (state, { idMaps }) => ({
    ...state,
    ...{ idMaps }
  })),
  on(saveScreens, (state, { saveScreensApiConstants, screensData }) => ({
    ...state,
    ...{ saveScreensApiConstants },
    ...{ screensData }
  })),
  on(updateScreens, (state, { screensApiConstants, screensData }) => {
    return {
      ...state,
      ...{ screensApiConstants },
      ...{ screensData }
    };
  }),
  on(setSelectedScreens, (state, { selectedScreens }) => {
    return {
      ...state,
      ...{ selectedScreens }
    };
  }),
  on(setNewlyAddedScreen, (state, { addedScreen }) => {
    return {
      ...state,
      ...{ addedScreen }
    };
  }),
  on(getScreenStructure, (state, { getScreenStructureApiConstants, sid }) => {
    return {
      ...state,
      ...{ getScreenStructureApiConstants },
      ...{ sid }
    };
  }),
  on(setScreenStructure, (state, { selectedScreenStructure }) => {
    return {
      ...state,
      ...{ selectedScreenStructure }
    };
  }),
  on(updateScreenStructure, (state, { updateStructureApiConstants, updatedStructure }) => {
    return {
      ...state,
      ...{ updateStructureApiConstants },
      ...{ updatedStructure }
    };
  }),
  on(deleteScreens, (state, { deleteScreenApi, screensId }) => {
    return {
      ...state,
      ...{ deleteScreenApi },
      ...{ screensId }
    };
  }),
  on(currentDeleteScreen, (state, { deletedScreenId }) => {
    return {
      ...state,
      ...{ deletedScreenId }
    };
  }),
  on(getFieldsInfoForTable, (state, { getFIApiConstants }) => {
    return {
      ...state,
      ...{ getFIApiConstants }
    };
  }),
  on(setFieldsInfoForTable, (state, { fieldsInfo }) => {
    return {
      ...state,
      ...{ fieldsInfo }
    };
  }),
  on(updateFieldsInfoForTable, (state, { updateFIApiConstants, fiData }) => {
    return {
      ...state,
      ...{ updateFIApiConstants },
      ...{ fiData }
    };
  }),
  on(getChildrenForElement, (state, { getChildrenApi, fetchType }) => {
    return {
      ...state,
      ...{ getChildrenApi },
      ...{ fetchType }
    };
  }),
  on(setChildrenForElement, (state, { elemChildren }) => {
    return {
      ...state,
      ...{ elemChildren }
    };
  }),
  on(generatePages, (state, { genPagesApi, genParams }) => {
    return {
      ...state,
      ...{ genPagesApi },
      ...{ genParams }
    };
  }),

  on(updateCurrentScreen, (state, { updateScreenApi, screenData }) => {
    return {
      ...state,
      ...{ updateScreenApi },
      ...{ screenData }
    };
  }),
  on(getChildTables, (state, { getChildTableApi, tableId }) => {
    return {
      ...state,
      ...{ getChildTableApi },
      ...{ tableId }
    };
  }),
  on(setChildTables, (state, { childTables }) => {
    return {
      ...state,
      ...{ childTables }
    };
  }),
  on(setErrorMessage, (state, { errorData }) => {
    return {
      ...state,
      errorData: errorData
    };
  }),
  on(setLandngScreen, (state, { apiConstants }) => {
    return {
      ...state,
      apiConstants
    };
  }),
  on(updateLandScr, (state, { landScrId }) => {
    return {
      ...state,
      ...{ landScrId }
    };
  }),
  on(saveconfAndFileCntSuccess, (state, { results }) => {
    return {
      ...state,
      results
    };
  }),
  on(saveconfAndFileCntFailure, (state, { error }) => {
    return {
      ...state,
      error
    };
  }),
  on(updateScnAndDMCOnfig, (state, { updateApiCons, updatedData }) => {
    return {
      ...state,
      ...{ updateApiCons },
      ...{ updatedData }
    };
  }),
  on(getTableOrder, (state, { tableOrderApiConstants }) => ({
    ...state,
    ...tableOrderApiConstants
  })),
  on(setTableOrder, (state, { tableOrder }) => ({
    ...state,
    ...{ tableOrder }
  })),
  on(getPagesForQuery, (state, { queryPagesApiConstants }) => ({
    ...state,
    ...queryPagesApiConstants
  })),
  on(setPagesForQuery, (state, { queryPages }) => ({
    ...state,
    ...{ queryPages }
  })),
  on(getTablesForQuery, (state, { queryTblsApiConstants }) => ({
    ...state,
    ...queryTblsApiConstants
  })),
  on(setTablesForQuery, (state, { queryTables }) => ({
    ...state,
    ...{ queryTables }
  })),
  on(getQueryTableData, (state, { queryTblDataApiConstants, sid }) => ({
    ...state,
    ...queryTblDataApiConstants,
    ...sid
  })),
  on(setQueryTableData, (state, { queryTableData }) => ({
    ...state,
    ...{ queryTableData }
  })),
  on(getStandardListPages, (state, { stdPagesApiConstants }) => ({
    ...state,
    ...stdPagesApiConstants
  })),
  on(setStandardListPages, (state, { standardPages }) => ({
    ...state,
    ...{ standardPages }
  })),
  on(getTableData, (state, { tblDataApiConstants, sid }) => ({
    ...state,
    ...tblDataApiConstants,
    ...sid
  })),
  on(setTableData, (state, { tableData }) => ({
    ...state,
    ...{ tableData }
  })),
  on(setMsScreenData, (state, { msScreenData }) => ({
    ...state,
    ...{ msScreenData}
  })),
  on(getPageVariables, (state, { getPageVariablesApiConst, data }) => ({
    ...state,
    ...getPageVariablesApiConst,
    ...data
  })),
  on(setPageVariables, (state, { setPageVariablesData }) => ({
    ...state,
    ...{ setPageVariablesData }
  })),
  on(savePageVariable, (state, { savePageVariableApiConst, data }) => ({
    ...state,
    ...{ savePageVariableApiConst },
    ...{ data }
  })),
  on(savePageVariableSuccess, (state, { savePageVariableSuccessData }) => ({
    ...state,
    ...{ savePageVariableSuccessData }
  })),
  on(deletePageVariable, (state, { deletePageVariableApiConst, data }) => ({
    ...state,
    ...{ deletePageVariableApiConst },
    ...{ data }
  })),
  on(deletePageVariableSuccess, (state, { deletePageVariableSuccessData }) => ({
    ...state,
    ...{ deletePageVariableSuccessData }
  })),
  on(setQueryMapData, (state, { queryMapData }) => ({
    ...state,
    ...{ queryMapData }
  }))
);
